import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Owl(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>You find the Owl inside a tree trunk in Sefton Park.</p>
          <p>
            The nocturnal bird is seemingly reading a book. You decide to make
            yourself known to the Owl who you doubt is going to look up.
          </p>
          <p>
            "Uhh... Hi" you say. The owl seems to be startled by this, and drops
            his book. Then you realise the bird was reading a book called 'How
            to sleep better at night for dummies'.
          </p>
          <p>
            "Oh- Oh hi. Sorry, I never saw you. Uh, what the flock do you want?
            Can't you see I'm hiding?" You are taken aback by this reaction. You
            expected the Owl to be a bit more polite.
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              Why are you hiding?
            </button>
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              What do you think of Liverpool
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />{" "}
        <div className={styles.questions}>
          <p>
            "Ugh. I am the knowledge keeper. If you couldn't gather that
            yourself. Now, I have very important tasks to complete - I am
            gathering intel about the humans so we can create better incident
            markers and get more points" the Owl explains. "The thing is that
            these cheeky Tits are mostly awake during daytime... I'm researching
            how to change my sleeping patterns so I can spy on them effectively"
            The Owl seems frustrated at the idea.
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              The Pigeon needs you back{" "}
            </button>
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              What do you think of Liverpool
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Plenty of rats to eat! That's a good thing actually, I love eating
            a good Mammal Folk! Also it's good for the Tournament hoohoohoo" the
            Owl laughs.
          </p>

          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              What Tournament
            </button>
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(5);
              }}
            >
              Do you eat rats!?
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "The sacred Tournament all Non-Humans of Liverpool are playing.
            Didn't you know there's a war going on? All the Folks in a Battle
            Royale style." you can see the fire of anger building up inside the
            Owl's big eyes.
          </p>
          <p>
            "The more points, the more chances we'll get to win... So we need to
            write the PERFECT incident markers! That's why I'm researching!
            Hoohoohoo!" an evil laugh escapes the Owl's beak.
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              The Pigeon needs you back
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Pigeon summons me? Something must be going on... A secret threat
            maybe?" The Owl drops its book as it prepares to fly away. "Would
            you mind picking up where I left it? I was about to create a great
            incident marker about being a nocturnal bird... Would you give it a
            go for me?" not waiting for an answer, the Owl has left you with
            some work to do.
          </p>

          <p>Perhaps it's time to place an Incident Marker...</p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 5) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          "I did say I was going to continue reading, did I not? If you must
          know, I clear up the rodents from human farms and streets. And yes, I
          LOVE FEELING THEIR BONES CRACKING UNDER MY BEAK'S PRESSURE!" the Owl
          looks like it needs some sleep.
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              The Pigeon needs you back
            </button>
          </p>
        </div>
      </div>
    );
  }
}

export default Owl;
